/* unplugin-vue-components disabled */import { render } from "./UserPhone.vue?vue&type=template&id=f313b48c&scoped=true"
import script from "./UserPhone.vue?vue&type=script&lang=js"
export * from "./UserPhone.vue?vue&type=script&lang=js"

import "./UserPhone.vue?vue&type=style&index=0&id=f313b48c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f313b48c"]])

export default __exports__